import { useState } from "react";
import { Check, Trash2, Phone, Mail } from "lucide-react";
import { Panel, StatusChip, BRL, fmtDate, iconBtn } from "./ui";

const FILTERS = [
  { k: "todas", label: "Todas" },
  { k: "confirmada", label: "Confirmadas" },
  { k: "pendente", label: "Aguardando PIX" },
  { k: "cancelada", label: "Canceladas" },
];

export const BookingsSection = ({ items, onUpdate, onDelete }) => {
  const [filter, setFilter] = useState("todas");
  const list = filter === "todas" ? items : items.filter((b) => b.status === filter);

  return (
    <Panel id="reservas" title="Reservas" subtitle="Reservas não pagas somem sozinhas após 30 minutos." testId="bookings-section"
      action={
        <div className="flex flex-wrap gap-1.5">
          {FILTERS.map((f) => (
            <button key={f.k} onClick={() => setFilter(f.k)} data-testid={`bookings-filter-${f.k}`}
              className={`px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${filter === f.k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
              {f.label}
            </button>
          ))}
        </div>
      }>
      {list.length === 0 ? (
        <p className="text-sm text-slate-500 text-center py-10">Nenhuma reserva aqui ainda.</p>
      ) : (
        <div className="space-y-2 max-h-[520px] overflow-y-auto pr-1">
          {list.map((b) => (
            <div key={b.id} className="rounded-2xl border border-slate-200 p-4 flex flex-col sm:flex-row sm:items-center gap-3 hover:border-[#0A66C2]/40 transition-colors" data-testid={`booking-${b.id}`}>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-bold text-slate-900">{b.guest_name}</span>
                  <StatusChip status={b.status} />
                  {b.kind === "tour" && <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-cyan-100 text-cyan-800">jet ski</span>}
                </div>
                <p className="text-sm text-slate-600 mt-0.5 truncate">{b.property_title}</p>
                {b.kind !== "tour" && <p className="text-xs text-slate-500 mt-0.5">{fmtDate(b.checkin)} → {fmtDate(b.checkout)} · {b.nights} noite(s)</p>}
                {(b.addons || []).map((a) => (
                  <p key={a.addon_id} className="text-xs text-amber-800 mt-0.5" data-testid={`booking-addon-${b.id}-${a.addon_id}`}>
                    Adicional: {a.name}{a.qty > 1 ? ` × ${a.qty}` : ""} · {BRL(a.subtotal)}
                  </p>
                ))}
                {b.coupon_code && <p className="text-xs text-emerald-700 mt-0.5" data-testid={`booking-coupon-${b.id}`}>Cupom {b.coupon_code}: −{BRL(b.discount_amount)}</p>}
                {(b.extras || []).map((x, i) => (
                  <p key={i} className="text-xs text-cyan-800 mt-0.5" data-testid={`booking-extra-${b.id}-${i}`}>
                    Jet ski: {x.title} · {fmtDate(x.date)} às {x.time} · {x.qty} jet ski(s) · {BRL(x.subtotal)}{x.combo_discount ? ` (combo −${BRL(x.combo_discount)})` : ""}
                  </p>
                ))}
                <div className="flex flex-wrap gap-3 mt-1.5 text-xs text-slate-500">
                  <a href={`https://wa.me/55${(b.guest_phone || "").replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-1 hover:text-emerald-600"><Phone size={11} /> {b.guest_phone}</a>
                  <a href={`mailto:${b.guest_email}`} className="flex items-center gap-1 hover:text-[#0A66C2]"><Mail size={11} /> {b.guest_email}</a>
                </div>
              </div>
              <div className="flex sm:flex-col items-center sm:items-end justify-between gap-1 shrink-0">
                <div className="text-right">
                  <div className="font-extrabold text-emerald-700">{BRL(b.deposit_amount)}</div>
                  <div className="text-[11px] text-slate-400">de {BRL(b.total_amount)}</div>
                </div>
                <div className="flex gap-1">
                  {b.status === "pendente" && (
                    <button title="Marcar como paga" className={`${iconBtn} hover:text-emerald-600`} data-testid={`booking-confirm-${b.id}`}
                      onClick={() => onUpdate(b.id, { status: "confirmada", confirmed_at: new Date().toISOString() })}>
                      <Check size={15} />
                    </button>
                  )}
                  <button title="Apagar" className={`${iconBtn} hover:text-red-600`} data-testid={`booking-delete-${b.id}`}
                    onClick={() => window.confirm(`Apagar a reserva de ${b.guest_name}?`) && onDelete(b.id)}>
                    <Trash2 size={15} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
